import { render, staticRenderFns } from "./InputImage.vue?vue&type=template&id=486020f7&scoped=true&"
import script from "./InputImage.vue?vue&type=script&lang=js&"
export * from "./InputImage.vue?vue&type=script&lang=js&"
import style0 from "./InputImage.vue?vue&type=style&index=0&id=486020f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486020f7",
  null
  
)

export default component.exports